<div class="qa-theming-tabbar">
  <p>{{_("Farbe, Schrift und Logo der Verwaltungsoberfläche für alle Benutzer dieser Instanz.")}}</p>
  <div class="qa-theming-actions">
    <button type="button" class="qa-theming-switch" role="switch" [attr.aria-checked]="!!theming.active" (click)="onToggle()"
            [disabled]="!theming.active && !canSave()">
      <span class="qa-switch-track" aria-hidden="true"><span class="qa-switch-thumb"></span></span>
      {{theming.active ? _("Theming aktiv") : _("Theming deaktiviert")}}
    </button>
    <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!canSave()">
      <i class="fa fa-save" aria-hidden="true"></i> {{_("Speichern")}}
    </button>
  </div>
</div>

<div class="qa-theming-layout">
  <div class="qa-theming-sections">

    <section class="qa-theming-card">
      <h3><i class="fa fa-desktop" aria-hidden="true"></i> {{_(KEYS.THEMING.ADMIN)}}</h3>

      <div class="qa-theming-fields">
        <div class="qa-theming-field">
          <label for="admin-color">{{_("Hauptfarbe")}}</label>
          <div class="qa-color-input">
            <span class="qa-color-swatch" [style.background]="theming.mainColor || 'transparent'" aria-hidden="true"></span>
            <input
              class="form-control" id="admin-color" spellcheck="false" autocomplete="off"
              [colorPicker]="theming.mainColor"
              (colorPickerChange)="onMainColorChange($event)"
              [value]="theming.mainColor || ''"
              [cpPosition]="'bottom'"
              [cpOKButtonClass]="'btn btn-primary'"
              [cpSaveClickOutside]="true"
              [cpOKButton]="true"
            />
          </div>
        </div>

        <div class="qa-theming-field">
          <label for="admin-font">{{_("Schriftart")}}</label>
          <select id="admin-font" class="form-control" [(ngModel)]="theming.font" (change)="onFontChange()">
            <option value="">{{_("Standard")}}</option>
            <option *ngFor="let font of fonts" [value]="font">{{font}}</option>
          </select>
        </div>
      </div>
      <p class="qa-theming-note">{{_("Helle und dunkle Abstufungen, Hover- und Fokusfarben werden aus der Hauptfarbe berechnet, für das helle und das dunkle Design.")}}</p>

      <div class="qa-theming-field">
        <label>{{_("Logo im Seitenmenü")}}</label>
        <div class="qa-logo-tile">
          <button type="button" class="qa-logo-stage" [class.qa-logo-empty]="!theming.logo" (click)="onOpenMediaCenterModalForLogo()"
                  [attr.aria-label]="theming.logo ? _('Logo ändern') : _('Logo wählen')">
            <img *ngIf="theming.logo; else noLogo" [src]="theming.logo.dataUrl" alt="" />
            <ng-template #noLogo><i class="fa fa-picture-o" aria-hidden="true"></i><span>{{_("Kein Logo")}}</span></ng-template>
          </button>
          <div class="qa-logo-actions">
            <button type="button" class="btn btn-outline-secondary" (click)="onOpenMediaCenterModalForLogo()">
              <i class="fa fa-folder-open-o" aria-hidden="true"></i> {{theming.logo ? _("Logo ändern") : _("Logo wählen")}}
            </button>
            <button type="button" class="qa-icon-action qa-icon-action-danger" (click)="onDeleteLogo()" [disabled]="!theming.logo"
                    [attr.aria-label]="_('Entfernen')" [attr.title]="_('Entfernen')">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="qa-theming-card">
      <h3><i class="fa fa-code" aria-hidden="true"></i> {{_("Eigenes CSS")}}</h3>
      <p class="qa-theming-text">{{_("Mit eigenen CSS-Regeln lässt sich die Verwaltungsoberfläche über diese Einstellungen hinaus anpassen.")}}</p>
      <div class="qa-css-row">
        <span class="qa-css-status" [class.qa-css-set]="customCssLines">
          <i class="fa" [ngClass]="customCssLines ? 'fa-check-circle' : 'fa-circle-o'" aria-hidden="true"></i>
          {{customCssLines ? customCssLines + ' ' + _("Zeilen eigenes CSS") : _("Keine eigenen Regeln hinterlegt")}}
        </span>
        <button type="button" class="btn btn-outline-secondary" (click)="onOpenCustomCssDialog()">
          <i class="fa fa-pencil" aria-hidden="true"></i> {{_("CSS bearbeiten")}}
        </button>
      </div>
    </section>
  </div>

  <aside class="qa-theming-preview" [attr.aria-label]="_('Vorschau')">
    <div class="qa-theming-card">
      <h3><i class="fa fa-eye" aria-hidden="true"></i> {{_("Vorschau")}}</h3>

      <div class="qa-mock-admin" [style]="previewTokens" aria-hidden="true">
        <div class="qa-mock-side">
          <div class="qa-mock-logo">
            <img *ngIf="theming.logo; else defaultLogo" [src]="theming.logo.dataUrl" alt="" />
            <ng-template #defaultLogo><img src="/assets/themes/mymedax/images/mymedax-logo.svg" alt="" /></ng-template>
          </div>
          <div class="qa-mock-nav qa-mock-nav-active"><i class="fa fa-file-text-o"></i> {{_("Fragebögen")}}</div>
          <div class="qa-mock-nav"><i class="fa fa-users"></i> {{_("Patienten")}}</div>
          <div class="qa-mock-nav"><i class="fa fa-cog"></i> {{_("Einstellungen")}}</div>
        </div>
        <div class="qa-mock-main">
          <div class="qa-mock-tabs"><span class="qa-mock-tab-active">{{_("Vorlagen")}}</span><span>{{_("Editor")}}</span></div>
          <div class="qa-mock-title">{{_("Fragebogen-Vorlagen")}}</div>
          <div class="qa-mock-card">
            <div class="qa-mock-input">{{_("Suche")}}</div>
            <div class="qa-mock-row qa-mock-row-selected"><span class="qa-mock-check"></span> {{_("Anamnese")}} <span class="qa-mock-badge">{{_("Freigegeben")}}</span></div>
            <div class="qa-mock-row"><span class="qa-mock-check qa-mock-check-off"></span> <span class="qa-mock-link">{{_("Aufklärung")}}</span></div>
            <div class="qa-mock-buttons"><span class="qa-mock-btn-outline">{{_("Abbrechen")}}</span><span class="qa-mock-btn">{{_("Speichern")}}</span></div>
          </div>
        </div>
      </div>

      <button type="button" class="btn btn-outline-secondary qa-preview-open" [class.active]="livePreview" (click)="onToggleLivePreview()"
              [disabled]="!canSave()" [attr.aria-pressed]="livePreview">
        <i class="fa" [ngClass]="livePreview ? 'fa-eye-slash' : 'fa-desktop'" aria-hidden="true"></i>
        {{livePreview ? _("Live-Vorschau beenden") : _("Live-Vorschau einschalten")}}
      </button>
      <p *ngIf="livePreview" class="qa-theming-note">{{_("Die Vorschau gilt nur für diese Seite und endet beim Verlassen. Gespeichert wird erst mit Speichern.")}}</p>
    </div>
  </aside>
</div>
